<template>
  <div class="fill-height">
    <!-- spacer for default destination -->
    <div v-if="isDefaultDestination" class="pt-12">
      <div class="pt-md-12 mt-md-12"></div>
    </div>

    <v-row class="justify-center no-gutters align-center z-index-5 mt-sm-6">
      <v-col class="col-12 col-md-6">
        <v-card
          :class="[isDefaultDestination ? 'opacity80' : 'white']"
          :tile="$vuetify.breakpoint.xsOnly"
        >
          <v-row class="pa-6 justify-center">
            <v-col class="col-12 col-md-8 text-center pa-0">
              <!-- login text -->
              <v-row class="pb-4 pt-6">
                <v-col class="col-12">
                  <div class="headline text-center">Login</div>
                </v-col>
              </v-row>

              <login-form />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoginForm from '../../login/LoginForm.vue'
export default {
  name: 'Login',

  components: {
    LoginForm,
  },

  computed: {
    isDefaultDestination() {
      return (
        this.$store.getters.getAppDestinationInstance() &&
        this.$store.getters.getAppDestinationInstance().isDefaultDestination()
      )
    },
  },
}
</script>
